import { getExtremumX, getExtremumY } from "./bar/extremums.js";
import seriesProcessor from "./bar/seriesProcessor.js";
import legendGetter from "./bar/legend.js";
import getColor from "./bar/getColor.js";
import keyboardFocusHandler from "./bar/keyboardFocusHandler.js";
import tooltipGetter, { axisTooltipGetter } from "./bar/tooltip.js";
import tooltipItemPositionGetter from "./bar/tooltipPosition.js";
import { getSeriesWithDefaultValues } from "./bar/getSeriesWithDefaultValues.js";
import { identifierSerializerSeriesIdDataIndex } from "../../internals/identifierSerializer.js";
export const barSeriesConfig = {
  seriesProcessor,
  colorProcessor: getColor,
  legendGetter,
  tooltipGetter,
  tooltipItemPositionGetter,
  axisTooltipGetter,
  xExtremumGetter: getExtremumX,
  yExtremumGetter: getExtremumY,
  getSeriesWithDefaultValues,
  keyboardFocusHandler,
  identifierSerializer: identifierSerializerSeriesIdDataIndex
};